// extracted by mini-css-extract-plugin
module.exports = {"root":"Chat_root__2uKnj","messages":"Chat_messages__1EUFN","dateDivider":"Chat_dateDivider__2hoOA"};